import { useState } from "react";
import type { Business } from "@dropin/shared/schemas";
import { createBusiness } from "../api";

function FieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <span className="text-xs font-semibold uppercase tracking-wider text-muted">
      {children}
    </span>
  );
}

export function BusinessSetup({ onCreated }: { onCreated: (b: Business) => void }) {
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const { business } = await createBusiness({
        name,
        city: city || undefined,
        address: address || undefined,
        description: description || undefined,
      });
      onCreated(business);
    } catch (err) {
      setError(err instanceof Error ? err.message : "failed");
      setSaving(false);
    }
  }

  return (
    <div className="card">
      <h2 className="text-xl font-semibold tracking-tightish">Set up your business</h2>
      <p className="mt-1 text-sm text-muted">One quick step before you can post perks.</p>
      <form onSubmit={submit} className="mt-5 grid gap-4" data-testid="business-setup-form">
        <label className="grid gap-1.5">
          <FieldLabel>Business name</FieldLabel>
          <input
            className="input"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Coral Roasters"
            data-testid="biz-name"
          />
        </label>
        <label className="grid gap-1.5">
          <FieldLabel>City</FieldLabel>
          <input
            className="input"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="San Francisco"
            data-testid="biz-city"
          />
        </label>
        <label className="grid gap-1.5">
          <FieldLabel>Address</FieldLabel>
          <input
            className="input"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="2200 Bryant St"
            data-testid="biz-address"
          />
        </label>
        <label className="grid gap-1.5">
          <FieldLabel>Description</FieldLabel>
          <textarea
            className="input min-h-[88px]"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="What's the vibe?"
            data-testid="biz-description"
          />
        </label>
        <div>
          <button
            type="submit"
            disabled={saving}
            className="btn-primary"
            data-testid="biz-submit"
          >
            {saving ? "Creating…" : "Create business"}
          </button>
        </div>
        {error && <p className="text-sm text-rose">{error}</p>}
      </form>
    </div>
  );
}
